import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import {constants, customStyles, STATUS} from "../../utils/constants";
import moment from "moment";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import swal from "sweetalert";
import {Button, Col, Dropdown, DropdownButton,Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {AddIconOutline, MenuDots, SearchIcon} from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";
import {DeleteModuleStep, GetModuleStep} from "../../services/modulesteps.service";
import {GetModule} from "../../services/module.service";
import Select from "react-select";

function ModuleSteps(props) {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [rows, setRows] = useState([]);
    const [modules, setModules] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const typingTimeoutRef = useRef(null);
    const [moduleValue, setModuleValue] = useState();

    useEffect(() => {
        getModuleStep();
    }, [keyword, page, perPage,status,moduleValue])


    useEffect(() => {
        getModule();
    }, [])

    const getModule = async () => {

        await GetModule(keyword, page, perPage,0,).then((result) => {
            if (result?.status) {
                if (result?.data) {
                    const rowData = [];
                    result?.data?.map((dt, index) => {
                        rowData.push({
                            id: dt._id || '-',
                            title: dt?.title || '-',
                        });

                    })
                    setModules(rowData);

                }
            }
        }).catch((error) => {

            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else if(error.response.status == 404) {
                setRows([]);
            }else {
                // return toast.error(error.response.data.message);
            }
        })
    }


    const convertHtmlToString = (html) => {
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(html, 'text/html');
        return parsedHtml.body.textContent || '';
    };

    const getModuleStep = async () => {
        setLoading(true)
        await GetModuleStep(keyword, page, perPage,1,status,moduleValue?.value).then((result) => {
            if (result?.status) {
                if (result?.data?.module_steps) {
                    const rowData = [];
                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result?.data?.pagination?.total);
                    result?.data?.module_steps?.map((dt, index) => {
                        rowData.push({
                            id: dt._id || '-',
                            title: dt?.title || '-',
                            module_id: dt?.module[0]?.title || '-',
                            content: convertHtmlToString(dt?.content) || '-',
                            status: STATUS[dt?.status],
                            duration: dt?.duration,
                            sequence: dt?.sequence,
                            created_at: moment(dt.created_at).fromNow(),
                            updated_at: (dt?.updated_at ? moment(dt?.updated_at).fromNow() : '-'),
                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else if(error.response.status == 404) {
                setRows([]);
            }else {
                return toast.error(error.response.data.message);
            }
        })
    }

    const onModuleStepDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this module step?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {

            if (willShip) {
                await DeleteModuleStep(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getModuleStep();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status == 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        history.push(`/module-steps/edit-module-step/` + data.id, {
            data: data
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots/>}>
                <Dropdown.Item as="button" onClick={() => onEdit(data)}>Edit</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onModuleStepDelete(data.id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }

    const columns = [
        {
            id: 'id',
            name: 'Id',
            grow: false,
            sortable: true,
            selector: rowData => rowData.id,
        },
        {
            id: 'module_id',
            name: 'Module',
            sortable: true,
            grow: false,
            center: true,
            selector: rowData => rowData.module_id,
        },
        {
            id: 'title',
            name: 'Title',
            sortable: true,
            minWidth:'200px',
            maxWidth: '300px',
            grow: false,
            selector: rowData => rowData.title,
        },
        {
            id: 'content',
            name: 'Content',
            grow: false,
            minWidth: '180px',
            maxWidth: '200px',
            selector: rowData => rowData.content,
        },
        {
            id: 'duration',
            name: 'Duration',
            grow: false,
            center: true,
            selector: rowData => rowData.duration,
        },
        {
            id: 'sequence',
            name: 'Sequence',
            grow: false,
            center: true,
            selector: rowData => rowData.sequence,
        },
        {
            id: 'status',
            name: 'Status',
            grow: false,
            center: true,
            selector: rowData => rowData.status,
        },
        {
            id: 'updated_at',
            name: 'Updated At',
            grow: false,
            center: true,
            selector: rowData => rowData.updated_at,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
        },
        {
            id: 'action',
            name: 'Action',
            cell: rowData => userActions(rowData)
        },
    ];

    const filterStatus = async (value) => {
        setStatus(value)
    }

    const handleKeyUp = (e) => {
        clearTimeout(typingTimeoutRef.current);

        const value = e.target.value;
        if (value.length > 2) {
            typingTimeoutRef.current = setTimeout(() => {
                setKeyword(value);
            }, 500); // Set keyword after 500 milliseconds of inactivity
        } else {
            setKeyword(null);
        }
    };

    const optionsModule = (item) => {

        setModuleValue(item)

    }

    return (
        <div className={"moduleStepsPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Module Steps</h1>
            <hr/>
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon/></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onKeyUp={handleKeyUp}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={12} sm={12} md={{span: 2, offset: 2}} lg={{span: 2, offset: 2}} xl={{span: 2, offset: 2}}>

                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Link to={"/module-steps/add-module-step"}>
                            <Button className={"btn btn-green-theme h40 w-100"}>
                                <AddIconOutline/> Add New
                            </Button>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col  xs={12} sm={12} md={8} lg={3} xl={3}>
                        <Form.Group className={"mb-3"} controlId="status">
                            <Form.Select className='formselect' aria-label="status"
                                         onChange={(e) => filterStatus(e.target.value)}
                                         value={status}
                            >
                                <option selected disabled value="" >Filter Status</option>
                                <option value={""}>All</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={5} lg={4} xl={3}>
                        <Form.Group className="mb-3" controlId="module">
                            <Select
                                value={moduleValue}
                                placeholder={'Filter module'}
                                options={modules && modules?.map(e => ({ label: e.title, value:e.id }))}
                                className="basic-multi-select"
                                onChange={optionsModule}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={{ span: 3, offset: 0 }} lg={{ span: 3, offset: 2}} xl={{ span: 2, offset: 4 }}>
                        <Button className={"btn btn-filter-theme h40 w-100"} onClick={()=>{
                            setStatus('')
                            setModuleValue(null)
                        }}>
                            Reset Filter
                        </Button>
                    </Col>
                </Row>
            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    columns={columns}
                    data={rows}
                    // actions={actionsMemo}
                    // data={data}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);


                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                                                  height={'4'} width={'100%'}/>}
                />
            </div>
        </div>
    )
}

export default ModuleSteps;